import React from "react";
import { Div, Text, Button } from "atomize";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import PrimaryButton from "../common/PrimaryButton";
import AnimateLink from "../common/AnimateLink";

const PodcastDiscord = () => {
  return (
    <>
      <Div>
        <WebsiteContainer>
          <CustomContainer>
            <Div className="podcast-discord-grid">
              <Div
                m="auto 0"
                order={{ xs: "2", md: "1" }}
                textAlign={{ xs: "center", md: "left" }}
              >
                <Text
                  textSize={{ xs: "30px", md: "36px" }}
                  style={{ lineHeight: "34px" }}
                  textWeight="800"
                  m={{ b: ".5rem" }}
                >
                  Join Our Discord Community
                </Text>
                <Text
                  textSize={{ xs: "paragraph2", md: "heading3" }}
                  textWeight="500"
                >
                  Interact with other ecommerce founders and access our monthly
                  fireside chats with industry experts. A (free!) resourceful
                  and friendly community for ecommerce founders.
                </Text>
                <AnimateLink to="https://airtable.com/shrH1QfmUSvjEFYHR">
                  <Button
                    bg="primary"
                    h="3.125rem"
                    w={{ xs: "100%", md: "auto" }}
                    p="0 1.5rem"
                    hoverBg="#FFCB6F"
                    textColor="black"
                    rounded="2px"
                    textWeight="800"
                    m={{ t: "1.625rem" }}
                  >
                    Join the Community
                  </Button>
                </AnimateLink>
              </Div>

              <Div
                bgImg="/images/discord.jpg"
                p={{ b: "100%" }}
                order={{ xs: "1", md: "2" }}
                bgSize="cover"
                bgPos="center"
              ></Div>
            </Div>
          </CustomContainer>
        </WebsiteContainer>
      </Div>
    </>
  );
};

export default PodcastDiscord;
